<template>
  <transition name="sign-success-modal-fade">
    <div v-if="modelValue" class="sign-success-modal-mask" @click.self="close">
      <div class="sign-success-modal-panel">
        <div class="sign-success-modal-title">{{ t("home.signSuccess") }}</div>
        <div class="sign-success-modal-actions">
          <button class="sign-success-btn" @click="goToShop">
            {{ t("home.goToShop") }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { clickButton, pageType } from "@/utils/point";

const { t } = useI18n();
const router = useRouter();

interface Props {
  modelValue: boolean;
}

const props = defineProps<Props>();
const emits = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();

const close = () => {
  emits("update:modelValue", false);
};

const goToShop = () => {
  clickButton({
    eventType: pageType.HOME,
    eventReason: "前往积分中心",
  });
  close();
  router.push("/shop");
};
</script>

<style scoped lang="scss">
.sign-success-modal-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.sign-success-modal-panel {
  width: 100%;
  max-width: 320px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

.sign-success-modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #222;
  text-align: center;
  margin-bottom: 24px;
}

.sign-success-modal-actions {
  display: flex;
  gap: 12px;
}

.sign-success-btn {
  flex: 1;
  padding: 12px 0;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  background: #ffb400;
  color: #fff;
}

.sign-success-modal-fade-enter-active,
.sign-success-modal-fade-leave-active {
  transition: opacity 0.2s;
}

.sign-success-modal-fade-enter-from,
.sign-success-modal-fade-leave-to {
  opacity: 0;
}
</style>
